import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["typeSelect", "fieldset", "submitButton", "allEntitiesRow"]

  connect() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
    }
  }

  typeChanged() {
    const selectedType = this.typeSelectTarget.value

    this.fieldsetTargets.forEach((fieldset) => {
      const active = fieldset.dataset.remediationType === selectedType
      fieldset.hidden = !active
      fieldset.disabled = !active
    })

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = !selectedType
    }

    if (this.hasAllEntitiesRowTarget) {
      this.allEntitiesRowTarget.hidden = !selectedType
    }
  }
}
